<div
    class="vertical-navigation-item-wrapper"
    [class.vertical-navigation-item-has-subtitle]="!!item.subtitle"
    [ngClass]="item.classes?.wrapper">

    <div
        class="vertical-navigation-item"
        [ngClass]="{'vertical-navigation-item-disabled': item.disabled}"
        [matTooltip]="item.tooltip ? (item.tooltip | transloco) : ''"
        (click)="toggleCollapsable()">

        <!-- Icon -->
        <!-- <ng-container *ngIf="item.icon">
            <mat-icon
                class="vertical-navigation-item-icon"
                [ngClass]="item.classes?.icon"
                [svgIcon]="item.icon"></mat-icon>
        </ng-container> -->

        <!-- Title & Subtitle -->
        <div class="vertical-navigation-item-title-wrapper" *transloco="let t;">
            <div class="vertical-navigation-item-title">
                <span [ngClass]="item.classes?.title">
                    {{t(item.title || '')}}
                </span>
            </div>
            <ng-container *ngIf="item.subtitle">
                <div class="vertical-navigation-item-subtitle">
                    <span [ngClass]="item.classes?.subtitle">
                        {{t(item.subtitle)}}
                    </span>
                </div>
            </ng-container>
        </div>

        <!-- Badge -->
        <ng-container *ngIf="item.badge">
            <div class="vertical-navigation-item-badge">
                <div
                    class="vertical-navigation-item-badge-content"
                    [ngClass]="item.badge.classes">
                    {{item.badge.title}}
                </div>
            </div>
        </ng-container>

        <!-- Arrow -->
        <mat-icon
            class="vertical-navigation-item-arrow icon-size-4 flex-shrink-0"
            [svgIcon]="'heroicons_solid:chevron-right'"></mat-icon>

    </div>

</div>

<div
    class="vertical-navigation-item-children"
    *ngIf="!isCollapsed"
    @collapse>

    <ng-container *ngFor="let item of item.children; trackBy: trackByFn">

        <!-- Skip the hidden items -->
        <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

            <!-- Basic -->
            <ng-container *ngIf="item.type === 'basic'">
                <vertical-navigation-basic-item
                    [item]="item"
                    [name]="name"></vertical-navigation-basic-item>
            </ng-container>

            <!-- Collapsable -->
            <ng-container *ngIf="item.type === 'collapsable'">
                <vertical-navigation-collapsable-item
                    [item]="item"
                    [name]="name"
                    [autoCollapse]="autoCollapse"></vertical-navigation-collapsable-item>
            </ng-container>

            <!-- Divider -->
            <ng-container *ngIf="item.type === 'divider'">
                <vertical-navigation-divider-item
                    [item]="item"
                    [name]="name"></vertical-navigation-divider-item>
            </ng-container>

            <!-- Group -->
            <ng-container *ngIf="item.type === 'group'">
                <vertical-navigation-group-item
                    [item]="item"
                    [name]="name"></vertical-navigation-group-item>
            </ng-container>

            <!-- Spacer -->
            <ng-container *ngIf="item.type === 'spacer'">
                <vertical-navigation-spacer-item
                    [item]="item"
                    [name]="name"></vertical-navigation-spacer-item>
            </ng-container>

        </ng-container>

    </ng-container>

</div>
